 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import BACKEDBIRDSFRONT_1 from '@/components/Backed/birdsfront_1'
 import LOVE_1 from '@/components/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLCONTENT from '@/components/xhtml/content'
 import XHTMLFRANTMATTER02 from '@/components/xhtml/frantmatter02'
 import XHTMLPART01 from '@/components/xhtml/part01'
 import XHTMLCHAPTER01 from '@/components/xhtml/chapter01'
 import LOVE_2 from '@/components/love_2'
 import XHTMLENDMATTER01 from '@/components/xhtml/endmatter01'
 import A2CHAP36 from '@/components/42-chap36'
 import A3BIO1 from '@/components/43-bio1'
 import A4BIO2 from '@/components/44-bio2'
 import A5BIO3 from '@/components/45-bio3'
 import A6BIO4 from '@/components/46-bio4'
 import A7BIO5 from '@/components/47-bio5'
 import A8BIO6 from '@/components/48-bio6'
 import A9BIO7 from '@/components/49-bio7'
 import A0BIO8 from '@/components/50-bio8'
 import A1BIO9 from '@/components/51-bio9'
 import A2BIO10 from '@/components/52-bio10'
 import A3BIO11 from '@/components/53-bio11'
 import A4BIO12 from '@/components/54-bio12'
 import A5BIO13 from '@/components/55-bio13'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import BACKEDBACKAD_1 from '@/components/Backed/backad_1'
 import BACKEDORIMAD_1 from '@/components/Backed/ORIM-ad_1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/content",
 			"name" : "xhtml/content",
 			"component" : XHTMLCONTENT
 		},
 		{
 			"path" : "/xhtml/frantmatter02",
 			"name" : "xhtml/frantmatter02",
 			"component" : XHTMLFRANTMATTER02
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js